// Fișierul: src/pages/Blog/components/content/curatenie-apartament-mutare-predare.js

export const content = `
<!-- CASETA TL;DR -->
<div style="background-color: #f8fafc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem auto; max-width: 800px; border-radius: 0 8px 8px 0;">
  <h3 style="margin-top: 0; color: #1e293b; font-size: 1.1rem; font-weight: 700;">TL;DR — Pe scurt</h3>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0;">
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Curățenia la mutare se realizează într-un spațiu gol, oferind acces liber în zone de regulă inaccesibile (spatele electrocasnicelor, interiorul dulapurilor, tocuri, rosturi).</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Înainte de predare protejează garanția de închiriere; după preluare asigură igiena absolută pentru noul locatar.</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Durează între 4 și 8 ore pentru o echipă profesionistă de 2 persoane într-un apartament de 2-3 camere.</li>
    <li style="margin-bottom: 0.6rem; padding-left: 1.5rem; position: relative;"><span style="position: absolute; left: 0; color: #1a73e8;">▸</span> Depășește curățenia generală prin gradul extrem de profunzime și degresare completă.</li>
  </ul>
</div>

<!-- CUPRINS ARTICOL -->
<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">Cuprins articol:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><a href="#de-ce-diferita" style="color: #1a73e8; text-decoration: none; font-weight: 600;">1. De ce curățenia la mutare este diferită de curățenia obișnuită</a></li>
    <li><a href="#cand-se-face" style="color: #1a73e8; text-decoration: none; font-weight: 600;">2. Când se face: înainte de predare sau după preluare</a></li>
    <li><a href="#zone-critice" style="color: #1a73e8; text-decoration: none; font-weight: 600;">3. Zonele critice la curățenia de mutare</a></li>
    <li><a href="#checklist" style="color: #1a73e8; text-decoration: none; font-weight: 600;">4. Checklist de predare-primire</a></li>
    <li><a href="#tabel-comparativ" style="color: #1a73e8; text-decoration: none; font-weight: 600;">5. Tabel comparativ: curățenie de mutare vs. generală vs. întreținere</a></li>
    <li><a href="#exemple-practice" style="color: #1a73e8; text-decoration: none; font-weight: 600;">6. Exemple practice de intervenție</a></li>
    <li><a href="#concluzie" style="color: #1a73e8; text-decoration: none; font-weight: 600;">7. Concluzie</a></li>
    <li><a href="#faq" style="color: #1a73e8; text-decoration: none; font-weight: 600;">8. Întrebări frecvente</a></li>
  </ul>
</div>

<p>Curățenia făcută la mutare are un scop diferit față de curățenia periodică a unei locuințe: nu urmărește doar aspectul plăcut, ci eliminarea completă a urmelor lăsate de foștii locatari și pregătirea spațiului gol pentru un nou început — fie pentru propria familie, fie pentru un chiriaș sau cumpărător.</p>

<p>Fără mobilier și obiecte personale care să blocheze accesul, această curățenie ajunge în zone de obicei ignorate: în spatele electrocasnicelor, în colțurile dulapurilor, pe tocurile ușilor sau în spatele caloriferelor, motiv pentru care este tratată distinct față de o intervenție standard.</p>

<!-- IMAGINE PRINCIPALA -->
<div style="margin: 2rem auto; text-align: center; max-width: 100%; width: 700px;">
  <img src="https://i.ibb.co/xS0QH8K6/Whats-App-Image-2026-09-16-at-10-35-56.webp" alt="curatenie apartament la mutare predare primire bucuresti" style="width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" />
</div>

<h2 id="de-ce-diferita">De ce curățenia la mutare este diferită de curățenia obișnuită</h2>
<p>O locuință mobilată și locuită impune limite firești oricărei echipe de igienizare: dulapurile sunt pline cu haine, blaturile de bucătărie au electrocasnice mici, iar în spatele canapelelor sau dulapurilor masive se aspiră rar. La predarea sau preluarea unui imobil, spațiul gol permite o abordare minuțioasă.</p>
<p>Serviciul de <a href="/curatenie-vile-apartamente/">curățenie pentru vile și apartamente</a> oferit de Doral Cleaning asigură eliminarea tuturor reziduurilor organice, a depunerilor vechi de grăsime și calcar și a mirosurilor neplăcute, oferind certitudinea unui mediu dezinfectat și sigur.</p>

<h2 id="cand-se-face">Când se face: înainte de predare sau după preluare</h2>
<p>Există două momente distincte în care are sens o curățenie de mutare, iar alegerea depinde de cine face predarea:</p>
<ul>
  <li><strong>Înainte de predare:</strong> proprietarul sau chiriașul care eliberează spațiul face curățenia pentru a preda locuința în stare impecabilă, adesea o condiție obligatorie stipulată în contractul de închiriere sau vânzare pentru restituirea integrală a garanției.</li>
  <li><strong>După preluare:</strong> noul locatar sau proprietar curăță temeinic apartamentul înainte de a-și muta mobila și hainele personale, chiar dacă spațiul pare curat vizual la o primă vedere.</li>
</ul>

<h2 id="zone-critice">Zonele critice la curățenia de mutare</h2>

<h3>Bucătărie: electrocasnice, hote, gresie</h3>
<p>Interiorul cuptorului, al frigiderului și al mașinii de spălat vase, filtrul metalic al hotei și rosturile dintre plăcile de gresie acumulează grăsime arsă și depuneri greu vizibile la o curățenie superficială. La mutare, aceste zone se degresează complet cu soluții profesionale, inclusiv spatele și dedesubtul electrocasnicelor mobile.</p>

<h3>Baie: calcar, rosături, sifoane</h3>
<p>Depunerile de calcar de pe baterii, cabina de duș sau paravanul de sticlă, precum și sifoanele de la chiuvetă și cadă, necesită produse anticalcar profesionale și timp adecvat de acțiune pentru a reda luciul original fără a mătuui suprafețele cromate.</p>

<h3>Pereți, uși, tocuri, prize</h3>
<p>Urmele de degete de pe pereți, praful acumulat pe tocurile ușilor și ramele ferestrelor, precum și zona din jurul întrerupătoarelor și prizelor sunt frecvent omise la curățenia de zi cu zi, dar devin imediat vizibile într-o cameră complet goală.</p>

<h3>Depozite, dulapuri, balcoane</h3>
<p>Interiorul corpurilor de mobilier rămase, cămara, debaraua și balconul trebuie aspirate și șterse complet de praf, pânze de păianjen sau resturi uitate, acordând atenție balamalelor, șinelor de glisare și glafurilor exterioare.</p>

<h2 id="checklist">Checklist de predare-primire</h2>
<p>Pentru a vă asigura că procesul de predare-primire decurge fără reproșuri, parcurgeți următoarea listă de verificare:</p>
<ul>
  <li>✔ Toate suprafețele orizontale (blaturi, pervazuri, rafturi) șterse și degresate</li>
  <li>✔ Electrocasnice curățate atât la exterior, cât și la interior (cuptor, frigider, hotă, microunde)</li>
  <li>✔ Baie și bucătărie dezinfectate, faianță spălată, fără urme de calcar sau mucegai</li>
  <li>✔ Geamuri spălate pe ambele fețe, împreună cu tocurile și garniturile ferestrelor</li>
  <li>✔ Pardoseli aspirate și spălate în toate încăperile, inclusiv colțurile și plintele</li>
  <li>✔ Prize, întrerupătoare, clanțe, uși și mânere șterse și dezinfectate</li>
  <li>✔ Balcon, debara și spații de depozitare golite și igienizate complet</li>
</ul>

<h2 id="tabel-comparativ">Tabel comparativ: curățenie de mutare vs. generală vs. întreținere</h2>
<div style="overflow-x: auto; margin: 2rem 0;">
  <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 0.95rem;">
    <thead>
      <tr style="background-color: #f1f5f9; border-bottom: 2px solid #cbd5e1;">
        <th style="padding: 12px; font-weight: 700;">Tip curățenie</th>
        <th style="padding: 12px; font-weight: 700;">Când se face</th>
        <th style="padding: 12px; font-weight: 700;">Profunzime</th>
        <th style="padding: 12px; font-weight: 700;">Zone acoperite</th>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Curățenie de mutare</td>
        <td style="padding: 12px;">Înainte de predare / după preluare, locuință goală</td>
        <td style="padding: 12px;">Foarte ridicată</td>
        <td style="padding: 12px;">Toate zonele, inclusiv spatele mobilierului fix și electrocasnicelor</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;"><a href="/curatenie-generala/">Curățenie generală</a></td>
        <td style="padding: 12px;">Periodic (sezonier/anual), locuință mobilată</td>
        <td style="padding: 12px;">Ridicată</td>
        <td style="padding: 12px;">Toate încăperile, cu accent pe zonele vizibile și de uz frecvent</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;"><a href="/curatenie-de-intretinere/">Curățenie de întreținere</a></td>
        <td style="padding: 12px;">Săptămânal sau bi-lunar, recurent</td>
        <td style="padding: 12px;">Standard</td>
        <td style="padding: 12px;">Suprafețe de uz zilnic: bucătărie, baie, pardoseli, praf</td>
      </tr>
    </tbody>
  </table>
</div>

<h2 id="exemple-practice">Exemple practice de intervenție</h2>
<h3>Exemplul 1: Curățenia bucătăriei înainte de predare</h3>
<ul>
  <li>Se scot sertarele și rafturile mobile din frigider și cuptor pentru curățare separată în chiuvetă.</li>
  <li>Se aplică detergent degresant profesional pe interiorul cuptorului, plită și hota cu filtre metalice.</li>
  <li>Se freacă mecanic rosturile dintre plăcile de gresie și zona din spatele aragazului sau frigiderului.</li>
  <li>Se șterg corpurile de bucătărie pe interior și exterior, inclusiv canturile superioare și balamalele.</li>
</ul>

<h3>Exemplul 2: Curățenia băii la preluarea unui apartament</h3>
<ul>
  <li>Se aplică soluție anticalcar cu acțiune prelungită pe baterii, faianță, cabină de duș și toaletă.</li>
  <li>Se demontează și se curăță sifoanele de scurgere de la chiuvetă și cadă pentru eliminarea mirosurilor.</li>
  <li>Se igienizează oglinzile, dulapurile suspendate și gurile de aerisire.</li>
</ul>

<h2 id="concluzie">Concluzie</h2>
<p>Curățenia la mutare este o investiție care protejează atât garanția de închiriere, cât și confortul și sănătatea familiei într-o locuință nouă. Accesul liber, fără mobilier, permite o curățare în profunzime imposibil de realizat într-un spațiu locuit zi de zi.</p>
<p>Echipa Doral Cleaning oferă servicii specializate de curățenie pentru apartamente și case în București și Ilfov, cu personal instruit, detergenți profesionali și utilaje performante pentru rezultate impecabile din prima zi.</p>

<h2 id="faq">Întrebări frecvente</h2>
<p><strong>Cine trebuie să facă curățenia la mutare: chiriașul care pleacă sau cel care se mută?</strong><br/>
Depinde de înțelegerea contractuală: de regulă, chiriașul care eliberează spațiul curăță înainte de predare pentru a-și recupera garanția, iar noul locatar poate solicita o igienizare suplimentară înainte de a-și aduce bunurile personale.</p>

<p><strong>Cât durează o curățenie completă de mutare pentru un apartament de 2-3 camere?</strong><br/>
În funcție de starea locuinței și de suprafață, o curățenie de mutare durează de obicei între 4 și 8 ore pentru o echipă formată din 2-3 persoane.</p>

<p><strong>Ce diferență este între curățenia de mutare și curățenia generală?</strong><br/>
Curățenia de mutare se face într-un spațiu complet gol, fără mobilier, și acoperă zone inaccesibile în mod normal (spatele electrocasnicelor, interiorul dulapurilor goale), spre deosebire de curățenia generală, făcută periodic într-o locuință mobilată.</p>

<p><strong>Este nevoie de echipamente speciale pentru calcar sau grăsime persistentă?</strong><br/>
Da, depunerile vechi de calcar sau grăsime polimerizată necesită soluții profesionale alcaline sau acide și, uneori, aparate cu abur sub presiune pentru a fi îndepărtate fără a zgâria suprafețele.</p>

<div style="background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); border-radius: 12px; padding: 2rem; margin: 2.5rem 0; text-align: center; color: #fff;">
  <p style="font-size: 1.15rem; font-weight: 600; margin-bottom: 0.5rem;">Te pregătești de mutare în București sau Ilfov?</p>
  <p style="margin-bottom: 1.2rem; opacity: 0.92;">Lasă curățenia în seama echipei noastre și bucură-te de un spațiu curat, igienizat și pregătit pentru locuit.</p>
  <a href="/contact-curatenie" style="background:#fff; color:#1a73e8; font-weight:700; padding:0.65rem 1.75rem; border-radius:8px; text-decoration:none; display:inline-block;">Solicită o ofertă de curățenie</a>
</div>
`;

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Cine trebuie să facă curățenia la mutare: chiriașul care pleacă sau cel care se mută?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Depinde de înțelegerea contractuală: de regulă, chiriașul care eliberează spațiul curăță înainte de predare, iar noul locatar poate solicita o curățenie suplimentară înainte de a-și muta bunurile."
      }
    },
    {
      "@type": "Question",
      "name": "Cât durează o curățenie completă de mutare pentru un apartament de 2-3 camere?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "În funcție de starea locuinței și de suprafață, o curățenie de mutare durează de obicei între 4 și 8 ore pentru o echipă de 2 persoane."
      }
    },
    {
      "@type": "Question",
      "name": "Ce diferență este între curățenia de mutare și curățenia generală?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Curățenia de mutare se face într-un spațiu gol, fără mobilier, și acoperă zone inaccesibile în mod normal (spatele electrocasnicelor, interiorul dulapurilor), spre deosebire de curățenia generală, făcută periodic într-o locuință mobilată."
      }
    },
    {
      "@type": "Question",
      "name": "Este nevoie de echipamente speciale pentru calcar sau grăsime persistentă?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da, depunerile vechi de calcar sau grăsime necesită soluții profesionale și, uneori, echipamente cu abur pentru a fi îndepărtate fără a deteriora suprafețele."
      }
    }
  ]
};
